import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import useAuthService from "../../auth/AuthService";

interface IHamburgerProps {
  isOpen?: boolean;
  handleClick?: () => void;
  handleLogout:() => void;
  isAuthenticated: boolean;
  is_fan1_verified: boolean;
  isNewNotification?: boolean;
}

const HamburgerSidebar: React.FC<IHamburgerProps> = ({
  isOpen,
  handleClick,
  isAuthenticated,
  is_fan1_verified,
  isNewNotification
}) => {
  const { logout, login, signup } = useAuthService();
  const navigate = useNavigate();

  const handleMenuClick = (event: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    if (!isAuthenticated) {
      event.preventDefault();
      localStorage.setItem("redirectPath", path);
      login();
    } else {
      handleClick?.();
    }
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      const redirectPath = localStorage.getItem("redirectPath");
      if (redirectPath) {
        navigate(redirectPath);
        localStorage.removeItem("redirectPath");
      }
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="filter-data position-relative mt-4">
      <div className="mb-4 mt-2 border-bottom">
        {isAuthenticated && is_fan1_verified && (
          <Link
            className="text-decoration-none d-block mb-2"
            to="/settings/listing"
            onClick={(e) => handleMenuClick(e, "/settings/listing")}
          >
            <p className="font-300-20 line-20 fs-5">My Listing</p>
          </Link>
        )}
        <Link
          className="text-decoration-none d-block mb-2"
          to="/memberships"
          onClick={(e) => handleMenuClick(e, "/memberships")}
        >
          <p className="font-300-20 line-20 fs-5">My Memberships</p>
        </Link>
        <Link
          className="text-decoration-none d-block mb-2"
          to="/alerts"
          onClick={(e) => handleMenuClick(e, "/alerts")}
        >
          <span className="alert-message pe-2 pt-1 m-0">
          <span className="font-300-20 line-20 fs-5 ">Messages / Alerts</span>
          {isNewNotification && <div className="alert-badge"></div>}
          </span>
        </Link>
        <Link
          className="text-decoration-none d-block mb-2"
          to="/following"
          onClick={(e) => handleMenuClick(e, "/following")}
        >
          <p className="font-300-20 line-20 fs-5">Following</p>
        </Link>
      </div>

      <div className="mb-4 mt-4 border-bottom">
        <Link className="text-decoration-none d-block mb-2" to="/rankings" onClick={handleClick}> 
          <p className="font-300-20 line-20 fs-5">Rankings</p>
        </Link>
        <Link className="text-decoration-none d-block mb-2" to="/available" onClick={handleClick}>
          <p className="font-300-20 line-20 fs-5">Available Now</p>
        </Link>
        {(!isAuthenticated && 

        <Link className="text-decoration-none d-block mb-2" to="/fans" onClick={handleClick}>
          <p className="font-300-20 line-20 fs-5">Fans</p>
        </Link>
        )}
        <Link className="text-decoration-none d-block mb-2" to="/famous" onClick={handleClick}>
          <p className="font-300-20 line-20 fs-5">Famous?</p>
        </Link>
      </div>

      <div className="mb-4">
        <Link className="text-decoration-none d-block mb-2" to="/learn" onClick={handleClick}>
          <p className="font-300-20 line-20 fs-5">Learn</p>
        </Link>
        <Link
          className="text-decoration-none d-block mb-2"
          to="/settings/profile"
          onClick={(e) => handleMenuClick(e, "/settings/profile")}
        >
          <p className="font-300-20 line-20 fs-5">Settings</p>
        </Link>
      </div>

      <div className="d-flex justify-content-center mobile-btn">
        {!isAuthenticated ? (
          <div className="d-flex justify-content-between auth-buttons">
            <Button
              label="Sign Up"
              onClick={()=>{signup()}}
              variant="none"
              className="mobile-bttn bg-color"
            />
            <Button
              label="Sign In"
              onClick={()=>{login()}}
              variant="none"
              className="mobile-bttn"
            />
          </div>
        ) : (
          <Button
            label={
              <>
                Sign Out <i className="ms-2 fa-solid fa-arrow-right-from-bracket"></i>
              </>
            }
            onClick={logout}
            variant="none"
            className="logout-btn btn-empty py-2 px-3"
          />
        )}
      </div>
    </div>
  );
};

export default HamburgerSidebar;
